<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-card class="w-100 rounded-lg">
      <v-card-title>{{ $t('spedilink.persons.filter') }}</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="localFilters.firstName"
          :label="$t('spedilink.persons.firstName')"
          outlined
          dense
          hide-details
          class="mb-2"
          clearable
        />
        <v-text-field
          v-model="localFilters.lastName"
          :label="$t('spedilink.persons.lastName')"
          outlined
          dense
          hide-details
          class="mb-2"
          clearable
        />
        <v-text-field
          v-model="localFilters.email"
          :label="$t('spedilink.persons.email')"
          outlined
          dense
          hide-details
          class="mb-2"
          clearable
        />
        <v-select
          v-model="localFilters.groups"
          :items="groups"
          :label="$t('spedilink.persons.groups')"
          item-text="name"
          item-value="name"
          multiple
          outlined
          dense
          hide-details
          class="mb-2"
          :loading="loadingGroups"
        />
      </v-card-text>
      <v-card-actions class="d-flex px-4 pb-4">
        <v-btn outlined @click="close()">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn color="primary" class="ml-auto" depressed @click="applyFilter()">
          {{ $t('spedilink.persons.filter') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'SpediLinkPersonsFilterDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      groups: [],
      loadingGroups: false
    }
  },
  computed: {
    localFilters: {
      get () {
        return this.filters
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.loadGroups()
      }
    }
  },
  methods: {
    async loadGroups () {
      this.loadingGroups = true
      try {
        const { data } = await Service.get('spedilink/SpediLinkGroups/GetList', {
          page: 1,
          pageSize: 1000
        })
        this.groups = data.results
      } catch (e) {
      } finally {
        this.loadingGroups = false
      }
    },
    close () {
      this.$emit('close')
    },
    applyFilter () {
      this.$emit('filter', this.filters)
    }
  }
}
</script>
